<template>
  <div :id="category.id">
    <div v-if="category.error && category.started && renderErrorBanner" class="alert">
      <span class="closebtn" v-on:click="closeWarning">&times;</span>
      There are errors on this page, please fix them to complete this category.
    </div>
    <h3>{{category.name}}</h3>
    <!-- <span v-if="beenFilled(category.questions)&&hasProfileQuestions(category.questions)" @click="fillWithProfile(category.questions)">Some questions can be filled with your profile information. Click here to do so</span> -->
    <div v-for="q in modCat" v-bind:key="q.id">
      <div v-if="Array.isArray(q)">
        <QuestionGroup :indexes="q" :questions="category.questions" :started="category.started" :categoryId="category.id" @removeQuestionGroup="$emit('removeQuestionGroup')"/>
      </div>
      <div v-else>
        <Question :qData="category.questions[q]" :started="category.started" :categoryId="category.id" />
      </div>
      <!-- {{q.answer}} -->
    </div>
  </div>
</template>

<script>
import Question from './Question.vue'
import QuestionGroup from './QuestionGroup.vue'
export default {
  name:'category',
  props:{
    category: Object,
    renderErrorBanner: Boolean
  },
  components:{
    Question,
    QuestionGroup
  },
  data(){
    return {
      modCat: []
    }
  },
  mounted() {
    this.fillRepeatGroups()
  },
  methods:{
    //hasProfileQuestions(questions){
    //  return questions.some(q => { return q.profile_map !== null })
    //},
    //fillWithProfile(questions){
    //  questions.forEach( q => {
    //    if(q.profile_map){
    //      q.answer.value = this.$store.getters.getProfileData[q.profile_map]
    //    }
    //  });
    //},
    beenFilled(questions){
      return questions.some( q => {
        return q.answer.value === "" && q.profile_map !== null
      })
    },
    fillRepeatGroups(){
      var modCatFill = []
      var questions = this.$props.category.questions
      var counter = 0
      for (var q = 0; q < questions.length; q++) {
        if (questions[q].repeatable) {
          if (q === 0 ) {
            //the first one
            modCatFill[counter] = []
            modCatFill[counter].push(q)
          } else if (Array.isArray(modCatFill[counter])) {
            if (questions[modCatFill[counter][0]].repeat_group === questions[q].repeat_group) {
              //another element of the same repeat group
              modCatFill[counter].push(q)
            } else {
              //an element of the next repeat group
              counter++
              modCatFill[counter] = []
              modCatFill[counter].push(q)
            }
          } else {
            //the first element of a new section
            counter++
            modCatFill[counter] = []
            modCatFill[counter].push(q)
          }
        } else {
          if (q !== 0) {
            counter++
          }
          modCatFill[counter] = q
        }
      }
      this.modCat = modCatFill
    },
    closeWarning(){
      this.renderErrorBanner = false
    }
  }
}
</script>

<style lang="scss" scoped>

.alert {
  padding: 20px;
  background-color: #f44336;
  color: white;
}
.closebtn {
  margin-left: 15px;
  margin-top: 2px;
  color: white;
  font-weight: bold;
  float: right;
  font-size: 22px;
  line-height: 20px;
  cursor: pointer;
  transition: 0.3s;
}

</style>

